import {GetStaticPaths, GetStaticProps} from 'next';

import {Layout, SelectStorePageTemplate} from 'src/components';
import {regionalConfigsArr} from 'src/config';
import {PageParams} from 'src/types';

interface SelectStorePageParams extends PageParams {
  slug: 'select-store';
}

interface SelectStorePagePath {
  params: SelectStorePageParams;
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths: SelectStorePagePath[] = regionalConfigsArr.reduce(
    (accumulatedPaths, config) => {
      const {locales, regionCode: region} = config;

      const localizedRegionalPaths: SelectStorePagePath[] = locales.map(
        (locale) => ({
          params: {region, locale, slug: 'select-store'},
        })
      );

      return [...accumulatedPaths, ...localizedRegionalPaths];
    },
    [] as SelectStorePagePath[]
  );

  return {paths, fallback: false};
};

export const getStaticProps: GetStaticProps<
  SelectStorePageParams,
  SelectStorePageParams
> = async ({params}) => {
  if (!params) {
    throw new Error('Could not find URL Page params for cart page');
  }

  return {
    props: {
      ...params,
    },
  };
};

const SelectStorePage: React.FC<
  React.PropsWithChildren<SelectStorePageParams>
> = (props) => {
  const {region, locale} = props;

  return (
    <Layout
      pageContext={{region, locale}}
      seo={{
        title: 'Select Regional Store', // TODO localize these strings
        description: 'Select a Stryd regional store',
        noIndex: true,
        includeInRegions: ['all'],
        slug: 'select-store',
        slugPrefix: '',
      }}
    >
      <SelectStorePageTemplate />
    </Layout>
  );
};

export default SelectStorePage;
